module.exports = __webpack_public_path__ + "img/offer-ico_1.272d6658.png";